import { render, staticRenderFns } from "./CompetitionsListFilters.vue?vue&type=template&id=2ef1c01a&scoped=true&"
import script from "./CompetitionsListFilters.vue?vue&type=script&lang=js&"
export * from "./CompetitionsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsListFilters.vue?vue&type=style&index=0&id=2ef1c01a&lang=scss&scoped=true&"
import style1 from "./CompetitionsListFilters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1c01a",
  null
  
)

export default component.exports